export default __webpack_public_path__ + "static/media/AlrtAIMockup.d255a0d0.webp";